import { getEnv } from 'common-nextjs';

/**
 * Facebook Pixel script code without loading the actual script.
 * This sets up capturing events until the real script loads.
 *
 * See also: FacebookPixel.tsx
 */
export function setupFacebookLocalCapture() {
  if (window.fbq || window._fbq) return;

  // prettier-ignore
  const n: any = window.fbq = function () {
    if (getEnv() !== 'production') {
      console.log(
        '[Facebook Local] fbq called with args:',
        Array.prototype.slice.call(arguments, 0),
      );
    }
    if (n.callMethod) {
      n.callMethod.apply(n, arguments);
    } else {
      n.queue.push(arguments);
    }
  };

  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];

  const fbKey = getEnv('FB_KEY');
  if (fbKey) {
    n('init', fbKey);
  }
}
